module.exports = __webpack_public_path__ + "img/GoogleLogo.edd0e34f.svg";